import { Component, OnInit } from "@angular/core";

@Component({
  selector: 'app-product',
  standalone: false,
  templateUrl: './product.component.html',
  styleUrl: './product.component.scss'
})
export class ProductComponent implements OnInit {
  
  ngOnInit(): void {
    
  }
}